import styled, { css } from 'styled-components';

export const FanseaPrimaryButton = styled.button<{ highlighted?: boolean }>`
  appearance: none;
  width: max-content;
  min-width: 15rem;
  height: 48px;
  padding: 0 1rem;
  border: 1px solid var(--color-text-default);
  border-radius: 2px;
  background: #08e8de;
  white-space: nowrap;
  line-height: 1;
  text-transform: uppercase;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  :disabled {
    pointer-events: none;
    color: var(--color-grey-700);
    border-color: var(--color-grey-700);
    background: var(--color-grey-800);
  }

  transition: background 200ms ease-out, border-color 200ms ease-out,
    color 200ms ease-out;

  ${({ highlighted = false }) =>
    highlighted &&
    css`
      background: var(--color-primary);
      border-color: var(--color-primary);
      color: var(--color-text-highlight);

      :disabled {
        border-color: var(--color-grey-800);
      }
    `};
`;
